import { login } from '@/api/api';

const ACCESS_TOKEN_PARAM = 'access_token';

export const captureAccessTokenFromUrl = (): void => {
  const url = new URL(window.location.href);
  const token = url.searchParams.get(ACCESS_TOKEN_PARAM);

  if (!token) {
    return;
  }

  login(token);

  url.searchParams.delete(ACCESS_TOKEN_PARAM);
  window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`);
};
